export default __webpack_public_path__ + "static/Honey-f4563eb32357b30ba0f3d5b497702673.jpg";